export default "__VITE_ASSET__B3JL9jNq__"